
































































































import BaseComponent from '@/components/base-component.vue';
import RulesEngineRuleForm from '@/components/rules-engine/rule/rule-form.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import { resetModalScroll } from '@/helpers/resetModalScroll';
import { PaginationSyncDTO, ResultPagDTO } from '@/interfaces/base-dto';
import { RestricaoFiltroPagDTO } from '@/interfaces/rules-engine';
import RuleModel from '@/models/rule-model';
import * as service from '@/services/rules-engine';
import {
  RULE_FILTER_TYPE_EMEDE, RULE_FILTER_TYPE_OVERRIDE
} from '@/settings/consts/rules-engine';
import RulesEngineOverrides from '@/views/rules-engine/screens/rules-overrides.vue';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    RulesEngineRuleForm,
    RulesEngineOverrides,
    ListMessages,
    PermissionAuth,
    UiToggleStatus
  },
})
export default class RulesEngineRuleList extends BaseComponent {
  @Prop()
  public filter: any;
  @Prop()
  public itemChanged?: any;

  public formOpen: boolean = false;
  public overridesListOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;

  public filterType: string = RULE_FILTER_TYPE_EMEDE;
  public filterTypes: any = {
    emede: RULE_FILTER_TYPE_EMEDE,
    override: RULE_FILTER_TYPE_OVERRIDE,
  };

  public filterTypesList: any[] = [
    {
      id: RULE_FILTER_TYPE_EMEDE,
      label: 'Regras',
    },
    {
      id: RULE_FILTER_TYPE_OVERRIDE,
      label: 'Hierarquias',
    },
  ];

  public ruleFormIsEdit: boolean = false;
  public ruleToEdit: any = null;
  public selectedRule: RuleModel = new RuleModel();

  pagination: PaginationSyncDTO = new PaginationSyncDTO();
  pagina: ResultPagDTO<any> = new ResultPagDTO();

  public headers: any = [
    { text: 'Código', value: 'codigo' },
    { text: 'Descrição', value: 'descricao' },
    { text: 'Tipo', value: 'acao' },
    { text: 'Ações', value: 'name', sortable: false, align: 'right' },
  ];

  public data: RuleModel[] = [];

  mounted() {
    this.registerLoadSubject();
  }

  private loadSubject$: BehaviorSubject<any> = new BehaviorSubject(null);
  
  public registerLoadSubject() {
    this.loadSubject$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(300),
        switchMap((filter) => {
          this.loading = true;
          this.error = false;
          this.data = []
          return service.findByFilter(filter);
        }),
      )
      .subscribe(
        (page) => {
          this.data = page.content;
          this.loading = false;
          this.pagina = page;
          PaginationSyncDTO.update(this.pagination, page);
        },
        (error) => {
          this.loading = false;
          this.error = true;
        },
      );
  }

  public load(): void {
    let filter = new RestricaoFiltroPagDTO();
    filter.termos = this.filter.term;
    filter.acao = this.filter.action;
    filter.ativo = this.filter.status;
    filter.update(this.pagination);

    this.loadSubject$.next(filter);
  }

  public onCloseOverridesClick(): void {
    this.overridesListOpen = false;
    this.selectedRule = new RuleModel();
  }

  public viewOverridesRules(item: RuleModel): void {
    this.selectedRule = item;
    this.overridesListOpen = true;
  }

  public newRule() {
    this.formOpen = true;
    this.ruleToEdit = new RuleModel();
    this.ruleFormIsEdit = false;
  }

  public closeForm() {
    this.formOpen = false;
    this.ruleToEdit = new RuleModel();
    this.ruleFormIsEdit = false;
    resetModalScroll();
  }

  public onDeleteItem(item: RuleModel) {
    const deleteItem = () => {
      this.loader.start('Deletando registro...');
      service.deleteRule(item.id).subscribe((data) => {
        this.loader.stop();
        this.load();
      }, (error => {
        this.loader.stop();
        this.showToastApiError(error);
      }));
    };

    this.dialog.show(
      'error',
      'Excluir Regra',
      'Tem certeza que deseja excluir esta regra?',
      'Cancelar',
      '',
      'Excluir',
      deleteItem,
    );
  }

  public onChangeSatusItem(item, newStatus) {
    this.$emit('changeStatus', item, newStatus);
  }

  @Watch('itemChanged')
  onItemChanged() {
    this.load();
  }

  public onEditItem(item: RuleModel) {
    this.loadIntoForm(item);
  }

  public onCloneItem(item: RuleModel) {
    this.loadIntoForm(item, true);
  }

  public loadIntoForm(item: RuleModel, clone: boolean = false): void {
    this.loader.start('Carregando regra...');
    service.getRule(item.id).subscribe(
      (data) => {
        this.loader.stop();
        if (clone) {
          data.id = null;
        }
        this.ruleToEdit = data;
        this.ruleFormIsEdit = !clone;
        this.formOpen = true;
      },
      (err) => {
        this.loader.stop();
        this.toast.show('Ocorreu um erro ao carregar a regra', 'error');
      },
    );
  }

  public onRuleSave() {
    this.closeForm();
    this.load();
  }

  public onAfterSave() {
    this.$emit('afterSave');
  }

  @Watch("filter", {immediate: true}) 
  onFilterChange() {
    this.pagination.page = 1;
    this.load();
  }

  @Watch('pagination.page')
  @Watch('pagination.rowsPerPage')
  @Watch('pagination.sortBy')
  @Watch('pagination.descending')
  private onChangePagination() {
    if (this.loading) {
      return;
    }
    this.load();
  }
}
